module.exports = __webpack_public_path__ + "media/img/corporate/logo-c9be3669fa3affd511f0686b48dc830f.svg";